
export type CancelEnrollment200Result = typeof CancelEnrollment200Result[keyof typeof CancelEnrollment200Result];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancelEnrollment200Result = {
  success: 'success',
} as const;
